<template><article><h1>间隔</h1>
<h3 id="多段间隔"><a class="header-anchor" href="#多段间隔" aria-hidden="true">#</a> 多段间隔</h3>
<p><example :value="example1"></example></p>
</article></template>

<script>
  import examples from '@/examples/interval.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>